import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import {
  primaryColor,
  secondaryColor,
} from "../Subscriptions/variables.styles";

const Container = styled.div`
  display: inline-block;
  opacity: 0.7;
  ${(props) =>
    props.fullScreen &&
    `
      width: ${props.vwidth ? props.vwidth : "100vw"};
      min-height: 40vh;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 999;
      position: fixed;
    `}
`;

const Linear = styled.div`
  span {
    display: inline-block;
    background-color: ${primaryColor};
    margin: 25px 5px;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    animation: bounce 1s ease-in-out infinite;
  }

  &::before {
    content: "";
    display: inline-block;
    background-color: ${primaryColor};
    margin: 25px 5px;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    animation: bounce 1s ease-in-out 0.33s infinite;
  }

  &::after {
    content: "";
    display: inline-block;
    background-color: ${primaryColor};
    margin: 25px 5px;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    animation: bounce 1s ease-in-out 0.66s infinite;
  }

  @keyframes bounce {
    0%,
    75%,
    100% {
      transform: translateY(0);
    }

    25% {
      transform: translateY(-1px);
    }
  }
`;

const LoadingStyles = styled.div`
  border: 3px solid ${primaryColor};
  border-top: 3px solid ${secondaryColor};
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loader = (props) => {
  const {
    fullScreen,
    bgColor,
    loaderColor,
    width,
    height,
    vwidth,
    show,
    linear,
  } = props;
  const { top, bottom, left, right } = loaderColor;
  const loaderStyle = {
    borderTopColor: top,
    borderBottomColor: bottom,
    borderLeftColor: left,
    borderRightColor: right,
    width,
    height,
  };
  return show ? (
    <Container fullScreen={fullScreen} bgColor={bgColor} vwidth={vwidth}>
      {linear ? (
        <Linear>
          <span />
        </Linear>
      ) : (
        <LoadingStyles style={loaderStyle} />
      )}
    </Container>
  ) : (
    ""
  );
};

Loader.propTypes = {
  show: PropTypes.bool,
  fullScreen: PropTypes.bool,
  bgColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  loaderColor: PropTypes.shape({
    top: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string,
    right: PropTypes.string,
  }),
};

Loader.defaultProps = {
  fullScreen: false,
  show: false,
  bgColor: "rgba(0, 0, 0, 0)",
  loaderColor: {
    top: secondaryColor,
    bottom: "#B6E8BC",
    left: "#B6E8BC",
    right: secondaryColor,
  },
  width: "50px",
  height: "50px",
};

export default Loader;
